import { Badge } from '@roger/ui-components';

/**
 * Canonical tooltip for the no-billable-visits marker (EMR-2423). A draft with
 * no non-missed billable visit cannot become a claim; most often it is a
 * period the nightly pass tiled before any visit landed, or a stale draft
 * left behind by an insurance switch, and the biller's move is to void it.
 */
export const NO_BILLABLE_VISITS_BADGE_TITLE =
  'This cycle has no billable visits. Void it if the period should not be billed.';

interface NoBillableVisitsBadgeProps {
  /** Layout-only classes for the call site (e.g. `self-start` in a flex column). */
  className?: string;
}

/**
 * Single source of truth for the no-billable-visits marker — label, styling,
 * and tooltip. Render conditionally on `has_billable_visits === false`; this
 * component does not gate itself, so the caller stays in control of when the
 * marker appears (same contract as InactiveEpisodeBadge).
 */
export function NoBillableVisitsBadge({
  className,
}: NoBillableVisitsBadgeProps) {
  return (
    <Badge
      variant='neutral'
      className={['whitespace-nowrap', className].filter(Boolean).join(' ')}
      title={NO_BILLABLE_VISITS_BADGE_TITLE}
    >
      No Billable Visits
    </Badge>
  );
}
